const HELP_TEXTS = {
  buttons: {
    zmsActive: 'All Brands that are linked to an Opportunity',
  },
};

export default HELP_TEXTS;
